export default {
  sections: {
    cookies_banner_section: {
      fields: {
        field_one: {
          value: {
            title: 'SEU Cookie-Popup & Datenschutzerklärung',
            description: 'Ihre Daten sind uns wichtig. Wir verwenden Cookies, um die Nutzung unserer Website für Sie zu verbessern und den Datenverkehr auf unserer Website zu analysieren. Wenn Sie «Ich stimme zu» wählen, stimmen Sie der Verwendung von Analyse- und Marketing-Cookies auf unserer Website zu.',
            buttonAccept: 'Ich stimme zu',
            acceptDescription: 'Ich stimme zu',
            buttonReject: 'Ich lehne ab',
            rejectDescription: 'Nein, danke.',
            privacyLink: 'Datenschutzerklärung',
          },
        },
      }
    },
  }
}
